export const UNEXPECTED_SERVER_ERROR_KEY = "TOASTR_MESSAGES.ERROR.UNEXPECTED_SERVER_ERROR";

const htmlMarkup = /<!doctype\s+html\b|<\/?[a-z][a-z0-9]*(?:\s[^<>]*)?\s*\/?>/i;

function messagesFrom(body: any): string[] {
  if (Array.isArray(body)) {
    return body.reduce((messages, item) => messages.concat(messagesFrom(item)), []);
  }
  if (!body || typeof body !== "object") {
    return [];
  }
  if (Array.isArray(body.feedback) && body.feedback.length) {
    return body.feedback.map((feedback) => feedback?.description);
  }
  if (body.exceptionMessage) {
    return [body.message, body.exceptionMessage];
  }
  return [body.description || body.message || (typeof body.error === "string" ? body.error : "")];
}

/** Format public feedback without displaying upstream pages or HTTP diagnostics. */
export async function formatErrorMessage(error: any, unexpectedServerMessage: string): Promise<string> {
  const isHttpError = typeof error?.status === "number";
  if (isHttpError && (error.status === 0 || error.status >= 500 ||
      (error.status >= 200 && error.status < 300) ||
      /text\/html/i.test(error.headers?.get("Content-Type") || ""))) {
    return unexpectedServerMessage;
  }

  let body = isHttpError ? error.error : error;
  try {
    if (body instanceof Blob) {
      // File-download endpoints can return their JSON error envelope as a Blob.
      body = JSON.parse(await body.text());
    } else if (typeof body === "string") {
      if (/^\s*[\[{]/.test(body)) {
        // Parse the envelope before inspecting only the displayed feedback.
        body = JSON.parse(body);
      } else {
        return isHttpError && body.trim() && !htmlMarkup.test(body) ? body : unexpectedServerMessage;
      }
    }
  } catch {
    return unexpectedServerMessage;
  }

  const messages = messagesFrom(body)
    .filter((message) => typeof message === "string" && !!message.trim());
  if (!messages.length || messages.some((message) => htmlMarkup.test(message))) {
    return unexpectedServerMessage;
  }
  return messages.join("\n");
}
